module.exports = __webpack_public_path__ + "assets/img/fomede_LIBER_salada.ed7a6a94.png";